jQuery(document).ready(function ($) {
  var sliderBreakpoint = 1200;

  var slickOptions = {
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 3500,
    speed: 500,
    infinite: true,
    pauseOnHover: true,
    pauseOnFocus: true,
    variableWidth: true,
    centerMode: true,
    adaptiveHeight: false,
    responsive: [
      // {
      //   breakpoint: 800,
      //   settings: {
      //     slidesToShow: 2,
      //   },
      // },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  // The static row is rigid (single-line, no shrink); when its content is wider
  // than the container it overflows, which is how we detect "doesn't fit".
  function staticRowFits($section) {
    var $row = $section.find(".points-row-static");
    if (!$row.length) {
      return true;
    }
    var row = $row[0];
    return row.scrollWidth <= row.clientWidth + 1;
  }

  function initQuickPointsBannerMarquee() {
    $(".quick_points_banner").each(function () {
      var $section = $(this);
      var responsiveBehavior = $section.data("responsive-behavior") || "slick";

      if (responsiveBehavior !== "slick") {
        return;
      }

      var $slider = $section.find(".points-row-slider");

      // Measure the static row in its natural (non-slider) state before deciding.
      $section.removeClass("use-slider");
      var needsSlider =
        window.innerWidth < sliderBreakpoint || !staticRowFits($section);

      if (needsSlider) {
        $section.addClass("use-slider");

        if ($slider.hasClass("slick-initialized")) {
          $slider.slick("setPosition");
        } else {
          $slider.slick(slickOptions);
        }

        return;
      }

      if ($slider.hasClass("slick-initialized")) {
        $slider.slick("unslick");
      }
    });
  }

  var resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initQuickPointsBannerMarquee, 150);
  }

  initQuickPointsBannerMarquee();
  $(window).on("resize.quickPointsBannerSlider", onResize);
});
